// DeadlineBadge.js — refactor 2026-05-21.
//
// Cell render component cho cột "Sắp hạn" trong list table.
//
// Hiển thị badge của deadline NGUY HIỂM NHẤT (worst case) — màu theo bucket
// (overdue/soon/near/ok). Hover → tooltip show từng deadline detail.
//
// Props:
//   - deadlines: Array<{ kind, label, short, date, daysLeft, bucket }>
//                  đã sort daysLeft ASC (từ deadlineCompute.computeDeadlines).
//   - kindKey:  "all" hoặc kind cụ thể — nếu cụ thể chỉ hiển thị 1 deadline đó.

import React from "react";
import { Box, Tooltip, Typography } from "@material-ui/core";
import { BUCKET_META } from "../../constants/deadlineKinds";
import { formatDaysLeft, formatDateVN } from "../../utils/deadlineCompute";

export default function DeadlineBadge({ deadlines, kindKey }) {
  let list = deadlines || [];
  if (kindKey && kindKey !== "all") {
    list = list.filter((d) => d.kind === kindKey);
  }

  if (list.length === 0) {
    return <span style={{ color: "#bbb" }}>—</span>;
  }

  // Worst case = item đầu (đã sort ASC).
  const worst = list[0];
  const meta = BUCKET_META[worst.bucket] || BUCKET_META.none;

  // Tooltip — show toàn bộ deadline applicable cho row (không filter kindKey
  // để admin có context đầy đủ).
  const tooltip = (
    <Box>
      {(deadlines || []).map((d) => {
        const m = BUCKET_META[d.bucket] || BUCKET_META.none;
        return (
          <Box
            key={d.kind}
            display="flex"
            alignItems="center"
            gridGap={6}
            padding="2px 0"
          >
            <span>{m.icon}</span>
            <Box flex={1}>
              <Typography variant="caption" style={{ color: "#fff", fontWeight: 600 }}>
                {d.label}
              </Typography>
              <Typography variant="caption" style={{ display: "block", color: "rgba(255,255,255,0.85)" }}>
                {formatDaysLeft(d.daysLeft)} — {formatDateVN(d.date)}
              </Typography>
            </Box>
          </Box>
        );
      })}
      {(deadlines || []).length === 0 && (
        <Typography variant="caption" style={{ color: "rgba(255,255,255,0.85)" }}>
          Không có deadline áp dụng.
        </Typography>
      )}
    </Box>
  );

  return (
    <Tooltip title={tooltip} arrow placement="left">
      <Box
        display="inline-flex"
        flexDirection="column"
        alignItems="flex-start"
        padding="2px 8px"
        bgcolor={meta.bg}
        border={`solid 1px ${meta.color}`}
        borderRadius={6}
        style={{ cursor: "help", maxWidth: "100%" }}
      >
        <Typography
          variant="caption"
          style={{ color: meta.color, fontWeight: 700, lineHeight: 1.2 }}
        >
          {meta.icon} {formatDaysLeft(worst.daysLeft)}
        </Typography>
        <Typography
          variant="caption"
          style={{ color: "#555", fontSize: 11, lineHeight: 1.2 }}
        >
          {worst.short}
        </Typography>
      </Box>
    </Tooltip>
  );
}
